<template>
  <div class="cv-temp-content" v-if="recommendTemps.length">
    <div class="title">
      <span>推荐简历</span>
      <div class="more" @click="moreTemplate">查看更多</div>
    </div>
    <div class="cv-temp" v-for="(temp, index) in recommendTemps" :key="index">
      <div class="temp-container">
        <div class="temp-header flex-between">
          <div class="title-wrapper flex-start">
            <span class="temp-title">{{ temp.cn }}</span>
            <img
              @click.stop="changeScaleStatus(temp)"
              class="plus-icon"
              src="https://files.wondercv.com/plus-search-icon.png"
              alt=""
            />
          </div>
          <div class="temp-btn flex-center">
            <div
              @click="changeTemp('cn', temp)"
              class="flex-center"
              :class="{ 'is-active': temp.currentLang === 'cn' }"
              v-if="temp.cn_img"
            >
              中文
            </div>
            <div
              @click="changeTemp('en', temp)"
              class="flex-center"
              :class="{ 'is-active': temp.currentLang === 'en' }"
              v-if="temp.en_img"
            >
              英文
            </div>
          </div>
        </div>
        <div class="temp-img">
          <div
            class="temp-mask flex-center"
            v-show="temp.use"
            @click="changeTemplateUse(temp)"
          >
            <div @click.stop="cvByTemp(temp)" class="use flex-center">
              使用模板
            </div>
          </div>
          <img
            @click="changeTemplateUse(temp)"
            :src="temp.currentLang === 'en' ? temp.en_img : temp.cn_img"
            alt=""
          />
        </div>
      </div>
      <div class="temp-description">
        <p>{{ temp.temp_desc }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { recommendTemps } from "@/assets/json/temps.json";

export default {
  name: "RecommendTemps",
  props: {
    // recommendTemps: {
    //   type: Array,
    //   default: []
    // }
  },
  data() {
    return {
      recommendTemps: [],
    };
  },
  watch: {},
  created() {
    this.getRecommendTemps();
  },
  computed: {
    // 推荐简历模板数组
    recTemps() {
      return recommendTemps;
    },
  },
  methods: {
    // 已登录无简历获取推荐模板
    async getRecommendTemps() {
      let recommendTemps = [];
      // this.getTemplateCv()
      let res = await this.$api.cv.getRecommendTemplate(this.cvAccountToken);
      if (res.code === 1000) {
        recommendTemps = this.recTemps.filter((i) =>
          res.data.names.includes(i.cv_type)
        );
        recommendTemps.forEach((item) => {
          if (item.cn_img) {
            item.currentLang = "cn";
          } else {
            item.currentLang = "en";
          }
        });
        this.recommendTemps = recommendTemps;
      }
    },
    changeScaleStatus(temp) {
      this.$emit("changeScaleStatus", temp);
    },
    cvByTemp(temp) {
      this.$emit("cvByTemp", temp);
    },
    changeTemplateUse(temp) {
      temp.use = !temp.use;
      this.$forceUpdate();
    },
    changeTemp(en, temp) {
      temp.currentLang = en;
      // this.$emit('changeTemp', en, temp)
    },
    moreTemplate() {
      this.$fn.jump(`${window.location.origin}/jianlimoban/tuijian/`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/global/variable";
@import "@/assets/scss/global/mixin";
.cv-temp-content {
  padding: 0 16px;
  margin-bottom: 24px;
  .title {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    color: #404040;
    font-weight: 500;
    .more {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 76px;
      height: 24px;
      border-radius: 12px;
      border: 1px solid #ececec;
      font-size: 13px;
      color: #606060;
    }
  }
  .cv-temp {
    box-shadow: 0 7px 19px 0 rgba(178, 178, 178, 0.13);
    border-radius: 6px;
    margin-bottom: 20px;
    border: 1px solid #f0f0f0;
    &:last-child {
      margin-bottom: 0;
    }
    .temp-container {
      background-color: $color-light;
      .temp-header {
        padding: 20px 18px;
        .title-wrapper {
          height: 26px;
          .temp-title {
            font-size: $font-size-medium-x;
            color: #424242;
            font-weight: bold;
          }
          .plus-icon {
            width: 16px;
            margin-left: 10px;
          }
        }
        .temp-btn {
          div {
            width: 46px;
            height: 26px;
            background-color: $color-light;
            border: 1px solid #50a4ff;
            color: #50a4ff;
            border-radius: 3px;
            font-size: $font-size-small;
            margin-right: 6px;
            &:last-child {
              margin-right: 0;
            }
          }
          .is-active {
            background-color: #50a4ff;
            color: $color-light;
            border: none;
          }
        }
      }
      .temp-img {
        padding: 0 30px;
        position: relative;
        .temp-mask {
          width: 70vw;
          height: 100%;
          background-color: rgba(255, 255, 255, 0.5);
          position: absolute;
          top: 0;
          .use {
            width: 100px;
            height: 32px;
            border-radius: 2px;
            background-color: $color-theme;
            color: $color-light;
          }
        }
        img {
          width: 100%;
        }
      }
    }
    .temp-description {
      color: #7f8fa4;
      font-size: 13px;
      padding: 18px 26px;
      line-height: 22px;
    }
  }
}
</style>
